export default [
  {id: 'm1', name: 'Moins de 100 c.c.', value: 0},
  {id: 'm2', name: 'Plus de 100 c.c.', value: 1},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/fr/arrays/displacement.js